import {faBacon} from '@fortawesome/free-solid-svg-icons';
import {BaseModel} from './base';

export class WorkflowCorrection extends BaseModel {
  static faIcon = faBacon;
}
